<div class="title-bar d-flex align-items-center justify-content-between my-4">
  <h2>
    {{
      (createOrEdit === "create"
        ? "MERCHANT.SITES.CREATE.TITLE"
        : "MERCHANT.SITES.EDIT.TITLE"
      ) | translate
    }}
  </h2>
  <button type="button" mat-stroked-button color="primary" (click)="onCancel()">
    <mat-icon>arrow_back</mat-icon>
    {{ "SHARED.BACK" | translate }}
  </button>
</div>

<app-merchant-site-edit
  *ngIf="
    !(
      (createOrEdit === 'edit' && (areSitesLoaded$ | async) === false) ||
      (isBasicDataLoaded$ | async) === false
    )
  "
  [site]="site$ | async"
  [basicData]="basicData$ | async"
  [error]="error$ | async"
  [isLoading]="(isLoading$ | async) ?? false"
  (submitted)="onSubmit($event)"
  (cancel)="onCancel()"
>
</app-merchant-site-edit>
